'use strict';

var omit = require('lodash.omit');
var isEqual = require('lodash.isequal');

function clean(query) {
  return omit(query, ['page', 'sortmode']);
}

module.exports = function (lastQuery, nextQuery, hasSavedSearch) {
  if (!hasSavedSearch) {
    return true;
  }
  return !isEqual(clean(lastQuery), clean(nextQuery));
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/@seek/seek-refine-job-search/dist/lib/can-save-search.js
 ** module id = 463
 ** module chunks = 0
 **/